import React from 'react';
import { DialogTitle, DialogContent, DialogActions, Dialog } from '../../AlmeDialog/AlmeDialog';
import { FocusComponentProps } from '../../../models/ComponentProps';

import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Button, Typography } from '@material-ui/core';
import { AlmeLiveChatControlsConfig } from './AlmeLiveChatControlsConfig';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(() =>
    createStyles({
        closeContainer: {
            display: 'inline-block',
        },
    }),
);

interface AlmeEndLiveChatDialogProps {
    onEndClick: () => void;
    onCancelClick: () => void;
    almeConfig: AlmeLiveChatControlsConfig;
    setIsDialogOpen: (isOpen: boolean) => void;
    focusProps?: FocusComponentProps;
    isOpen: boolean;
}

const AlmeEndLiveChatDialog: React.FC<AlmeEndLiveChatDialogProps> = (props: AlmeEndLiveChatDialogProps) => {

    const classes = useStyles();
    const handleEndClick = () => {
        props.onEndClick();
        props.onCancelClick();
    };

    return (
        <div className={classes.closeContainer}>
            <Dialog
                disableEnforceFocus
                id="alme-end-live-chat-dialog"
                aria-labelledby="alme-end-live-chat-dialog-title"
                aria-describedby="alme-end-live-chat-dialog-description"
                open={props.isOpen}
                onClose={props.onCancelClick}
                setIsDialogOpen={props.setIsDialogOpen}
                fullWidth
            >
                <DialogTitle id="alme-end-live-chat-dialog-title" almeConfig={props.almeConfig.liveChatControls} onClose={props.onCancelClick}>
                    <FormattedMessage
                        id="liveChatEndDialog.DialogTitleText"
                        defaultMessage="Default live chat dialog title text"
                        description="AlmeClose dialog title text" />
                </DialogTitle>
                <DialogContent dividers>
                    <Typography gutterBottom id="alme-end-live-chat-dialog-description">
                        <FormattedMessage
                            id="liveChatEndDialog.DialogBodyText"
                            defaultMessage="Default live chat dialog body text"
                            description="AlmeClose dialog body text" />
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button id='alme-end-live-chat-dialog-cancel-button'
                        variant={props.almeConfig.liveChatControls.dialog.styles.buttons.variant}
                        color={props.almeConfig.liveChatControls.dialog.styles.buttons.color}
                        onClick={props.onCancelClick}>
                        <FormattedMessage
                            id="liveChatEndDialog.declineButtonText"
                            defaultMessage="Default Cancel"
                            description="AlmeEndLiveChatDialog decline button text" />
                    </Button>
                    <Button id='alme-end-live-chat-dialog-end-button'
                        variant={props.almeConfig.liveChatControls.dialog.styles.buttons.variant}
                        color={props.almeConfig.liveChatControls.dialog.styles.buttons.color}
                        onClick={handleEndClick}>
                        <FormattedMessage
                            id="liveChatEndDialog.acceptButtonText"
                            defaultMessage="Default End"
                            description="AlmeEndLiveChatDialog accept button text" />
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
export default AlmeEndLiveChatDialog;